import apiClient from "../apiClient";
import ENDPOINTS from "../endpoints";

// 🔐 Login
export const loginUser = async (data) => {
  const response = await apiClient.post(ENDPOINTS.LOGIN, data);

  // Save token
  if (response.data?.access) {
    sessionStorage.setItem("access", response.data.access);
  }

  return response.data;
};

// 📝 Register
export const registerUser = async (data) => {
  const response = await apiClient.post(ENDPOINTS.REGISTER, data);
  return response.data;
};

export const verifyOTP = async (data) => {
    const response = await apiClient.post(ENDPOINTS.OTP_VERIFY, data);
    return response.data;
};

export const resendOTP = async (data) => {
    const response = await apiClient.post(ENDPOINTS.OTP_RESEND, data);
    return response.data;
};

// 🚪 Logout
export const logoutUser = async() => {
    const response = await apiClient.get(ENDPOINTS.LOGOUT);
    sessionStorage.clear();
    return response;
};

export const resetPassword = async (data) => {
    const response = await apiClient.post(ENDPOINTS.RESET_PASSWORD, data);
    return response.data;
};

export const resetPasswordConfirm = async (data) => {
    const response = await apiClient.post(ENDPOINTS.RESET_PASSWORD_CONFIRM, data);
    return response.data;
}